import React from 'react';
import { Dialog } from 'extended-oxygen-elements';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from 'oxygen-elements';
import { WarningAmberOutlinedIcon } from 'element';
import { DutyShortfall } from 'type';

interface Props {
  open: boolean;
  location: string;
  dayDate: string;
  shortfalls: DutyShortfall[];
  onApproveAnyway: () => void;
  onReject: () => void;
}

export const DutyCoverageConfirmModal = ({
  open,
  location,
  dayDate,
  shortfalls,
  onApproveAnyway,
  onReject,
}: Props) => {
  const primaryShortfall = shortfalls[0];

  return (
    <Dialog maxWidth="sm" open={open} onClose={onReject} id="duty-coverage-confirm-modal">
      <DialogTitle>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <WarningAmberOutlinedIcon style={{ color: '#b1101e' }} />
          Duty requirement at risk
        </span>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" gutterBottom>
          Approving this change will leave <strong>{location}</strong> on{' '}
          <strong>{dayDate}</strong> without the required{' '}
          {primaryShortfall
            ? `${primaryShortfall.duty_name} coverage (${primaryShortfall.fulfilled}/${primaryShortfall.required} required)`
            : 'required duty coverage'}
          . This may impact health &amp; safety compliance.
        </Typography>

        {shortfalls.length > 1 && (
          <div style={{ marginTop: 12 }}>
            {shortfalls.map((shortfall) => (
              <div
                key={shortfall.duty_id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '4px 0',
                  borderBottom: '1px solid #f0f0f0',
                  fontSize: 14,
                }}
              >
                <span>{shortfall.duty_name}</span>
                <span style={{ color: '#b1101e', fontWeight: 500 }}>
                  {shortfall.fulfilled} / {shortfall.required} required
                </span>
              </div>
            ))}
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          onClick={onReject}
          id="duty-coverage-reject-btn"
        >
          Reject
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onApproveAnyway}
          id="duty-coverage-approve-anyway-btn"
        >
          Approve anyway
        </Button>
      </DialogActions>
    </Dialog>
  );
};
